export const DOMAIN_API = 'https://api.eboxenterprises.com';
export const DOMAIN_API_SENETPRO = 'https://api.senetpro.com';
